import { userGroupActions } from "../user-group-actions";

const userGuideUrl = window.location.hostname.includes('localhost') ? 'http://localhost:8000/storage/public/2021-05-13-dealer-manual.pdf' : `https://adelphi.nyc3.digitaloceanspaces.com/public/CabiNet%20dealer%20manual%202021-07-28.pdf`

export const showroomMenu: any[] = [
	{
		title: "Dashboard",
		desc: "Showroom Dashboard",
		root: true,
		icon: "flaticon-line-graph",
		page: "/showroom/dashboard",
		// badge: {type: 'm-badge--danger', value: '2'},
		translate: "MENU.DASHBOARD"
	},
	{
		title: "Customers",
		desc: "Customers",
		root: true,
		icon: "flaticon-users",
		page: "/showroom/customers",
		actionId: userGroupActions.showroom.CUSTOMERS.INDEX
	},
	{
		title: "Estimates",
		desc: "Estimates",
		root: true,
		icon: "flaticon-list-1",
		page: "/showroom/proposals",
		actionId: userGroupActions.showroom.PROPOSALS.INDEX
		// bullet: "dot",
		// submenu: [
		// 	{
		// 		title: "Pricing",
		// 		page: "/showroom/proposals",
		// 		actionId: userGroupActions.showroom.PROPOSALS.INDEX
		// 	},
		// 	{
		// 		title: 'Contracts',
		// 		page: '/showroom/sent-contracts',
		// 	}
		// ]
	},
	{
		title: "Orders",
		desc: "Orders",
		root: true,
		icon: "flaticon-truck",
		page: "/showroom/orders",
		actionId: userGroupActions.showroom.ORDERS.INDEX
	},
	// {
	// 	title: 'Reports',
	// 	desc: 'Reports',
	// 	root: true,
	// 	icon: 'flaticon-notes',
	// 	page: '/showroom/reports',
	// },
	// {
	// 	title: "RMA",
	// 	desc: "RMA",
	// 	root: true,
	// 	icon: "flaticon-open-box",
	// 	page: "/showroom/rmas",
	// 	actionId: userGroupActions.showroom.RMA.INDEX
	// },
	{
		title: "Calendar",
		desc: "Calendar",
		root: true,
		icon: "flaticon-calendar-1",
		page: "/showroom/calendar",
		actionId: userGroupActions.showroom.CALENDAR.INDEX
	},
	{
		title: "Resources",
		desc: "Resources",
		root: true,
		icon: "flaticon-folder-1",
		page: "/showroom/resources",
		actionId: userGroupActions.showroom.RESOURCES.INDEX
	},
	// {
	// 	title: "Feedback",
	// 	desc: "Feedback",
	// 	root: true,
	// 	icon: "flaticon-comment",
	// 	page: "/showroom/feedback",
	// 	actionId: userGroupActions.showroom.FEEDBACK.INDEX
	// },
	// {
	// 	title: "Promotions",
	// 	desc: "Promotions",
	// 	root: true,
	// 	icon: "flaticon-mail",
	// 	page: "/showroom/promotions",
	// 	bullet: "dot",
	// 	submenu: [
	// 		{
	// 			title: "Activity",
	// 			page: "/showroom/promotions/activity"
	// 		}
	// 	]
	// },
	{
		title: 'Support',
		desc: 'Support',
		root: true,
		icon: 'flaticon-support',
		href: userGuideUrl
		// page: '/showroom/support',
	},
	// {
	// 	title: "Support",
	// 	desc: "Support",
	// 	root: true,
	// 	icon: "flaticon-light",
	// 	page: "/showroom/support"
	// 	// bullet: "dot",
	// 	// submenu: [
	// 	// 	{
	// 	// 		title: "Support",
	// 	// 		page: "/showroom/support"
	// 	// 	},
	// 	// 	// {
	// 	// 	// 	title: "Knowledgebase",
	// 	// 	// 	page: "https://kitchendev.freshdesk.com/support/solutions",
	// 	// 	// },
	// 	// 	// {
	// 	// 	// 	title: "Create Ticket",
	// 	// 	// 	page: "https://kitchendev.freshdesk.com/support/tickets/new",
	// 	// 	// },
	// 	// 	// {
	// 	// 	// 	title: "New Catalog",
	// 	// 	// 	page: "/showroom/requests/vendors",
	// 	// 	// 	privateLabelOnly: true,
	// 	// 	// 	actionId: userGroupActions.showroom.REQUESTS.NEW_MANUFACTURER.INDEX
	// 	// 	// },
	// 	// 	// {
	// 	// 	// 	title: "Price Change",
	// 	// 	// 	page: "/showroom/requests/prices",
	// 	// 	// 	privateLabelOnly: true,
	// 	// 	// 	actionId: userGroupActions.showroom.REQUESTS.PRICE_CHANGE.INDEX
	// 	// 	// }
	// 	// ]
	// },
	{
		title: "Settings",
		desc: "Settings",
		root: true,
		icon: "flaticon-settings",
		bullet: "dot",
		submenu: [
			{
				title: "General",
				page: "/showroom/settings/showroom-info",
				actionId: userGroupActions.showroom.SETTINGS.GENERAL.INDEX
			},
			{
				title: "Manufacturers",
				page: "/showroom/settings/vendors",
				actionId: userGroupActions.showroom.SETTINGS.MANUFACTURERS.INDEX
			},
			{
				title: "Users",
				page: "/showroom/settings/users",
				actionId: userGroupActions.showroom.SETTINGS.USERS.INDEX
			},
			{
				title: "Taxes",
				page: "/showroom/settings/taxes",
				actionId: userGroupActions.showroom.SETTINGS.TAXES.INDEX
			},
			// {
			// 	title: "Visual proposals",
			// 	page: "/showroom/settings/visual-proposals",
			// 	actionId:
			// 		userGroupActions.showroom.SETTINGS.VISUAL_PROPOSALS.INDEX
			// },
			{
				title: "Locations",
				page: "/showroom/settings/locations",
				actionId: userGroupActions.showroom.SETTINGS.LOCATIONS.INDEX
			},
			// {
			// 	title: "Integrations",
			// 	page: "/showroom/settings/integrations",
			// 	actionId: userGroupActions.showroom.SETTINGS.INTEGRATIONS.INDEX,
			// },
			// {
			// 	title: "Promotions",
			// 	page: "/showroom/settings/promotions",
			// 	actionId: userGroupActions.showroom.SETTINGS.PROMOTIONS.INDEX
			// },
			// {
			// 	title: "Permissions",
			// 	page: "/showroom/settings/user-groups",
			// 	actionId: userGroupActions.showroom.SETTINGS.PERMISSIONS.INDEX
			// },
			{
				title: "Audit Logs",
				page: "/showroom/settings/audit-logs",
				actionId: userGroupActions.showroom.SETTINGS.AUDIT_LOGS.INDEX
			},
			// {
			// 	title: 'Contracts',
			// 	page: '/showroom/settings/contracts'
			// },
			// {
			// 	title: 'Expenses',
			// 	page: '/showroom/settings/expenses'
			// }
		]
	}
];
